import { observer } from 'mobx-react';
import { FormFieldLine } from '../../../../../../components/form-field-line/form-field-line';
import { Input } from '../../../../../../components/inputs/input/input';
import { IValidationGroup } from '../../../../../../hooks/validation-group/validation-group-hook';
import PicqerCredentialsStore from "../../../stores/credentials/picqer-credentials-store";

interface IIntegrationProps {
    credentialsStore: PicqerCredentialsStore,
    vGroup: IValidationGroup,
}

const PicqerCredentials: React.FC<IIntegrationProps> = observer(({credentialsStore, vGroup}) => {
    return (
        <>
            <FormFieldLine label='Api Key' required key='api_key'>
                <Input
                    value={credentialsStore.api_key}
                    onChange={v => credentialsStore.api_key = v}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine label='Account subdomain' required key='account_subdomain'>
                <Input
                    value={credentialsStore.account_subdomain}
                    onChange={v => credentialsStore.account_subdomain = v}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine label='ID of the return status in Picqer' required key='idreturn_status'>
                <Input
                    value={credentialsStore.idreturn_status}
                    onChange={v => credentialsStore.idreturn_status = v}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine label='ID of the default return reason In Picqer' required key='warehouse'>
                <Input
                    value={credentialsStore.idreturn_reason}
                    onChange={v => credentialsStore.idreturn_reason = v}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
        </>
    )
});

export default PicqerCredentials;
